import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import AuthenticationHub from './pages/authentication-hub';
import EnterpriseClientDashboard from './pages/enterprise-client-dashboard';
import RetailPartnerDashboard from './pages/retail-partner-dashboard';
import RetailUserDashboard from './pages/retail-user-dashboard';
import FinancialDataAggregation from './pages/financial-data-aggregation';
import SuperAdministratorDashboard from './pages/super-administrator-dashboard';
import BudgetManagement from './pages/budget-management';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<AuthenticationHub />} />
        <Route path="/authentication-hub" element={<AuthenticationHub />} />
        <Route path="/enterprise-client-dashboard" element={<EnterpriseClientDashboard />} />
        <Route path="/retail-partner-dashboard" element={<RetailPartnerDashboard />} />
        <Route path="/retail-user-dashboard" element={<RetailUserDashboard />} />
        <Route path="/financial-data-aggregation" element={<FinancialDataAggregation />} />
        <Route path="/super-administrator-dashboard" element={<SuperAdministratorDashboard />} />
        <Route path="/budget-management" element={<BudgetManagement />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
